import BaseElement from './BaseElement'
import { WishlistSharedDisplay } from '../components/WishlistSharedDisplay'

export default class WishlistDashboardElement extends BaseElement {
  renderElement() {
    this.rootElement.render(<WishlistSharedDisplay />)
  }
}
